export const InputField = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  required = false,
  placeholder,
  disabled,
  options,
  defaultOptionLabel = "Select...",
  error,
  labelColor = "text-white",
  accept,
  rows = 4,
  style,
  startIcon,
  labelClassName = "",
  ...props
}) => {
  const hideLabel = labelClassName.includes("sr-only");

  return (
    <div
      className={`w-full ${hideLabel ? "flex items-center" : "flex flex-col"}`}
    >
      {label && (
        <label
          htmlFor={name}
          className={`${labelColor} mb-2 ${labelClassName} ${
            hideLabel ? "mb-0" : ""
          }`}
        >
          {label} {required && "*"}
        </label>
      )}

      {type === "select" ? (
        <select
          name={name}
          id={name}
          value={value}
          onChange={onChange}
          required={required}
          disabled={disabled}
          aria-describedby={error ? `${name}-error` : undefined}
          className={`input w-full p-2 border rounded-xl bg-white text-black disabled:bg-gray-100 disabled:text-gray-500 ${
            error ? "border-red-900" : "border-gray-300"
          }`}
          {...props}
        >
          <option value="" disabled>
            {defaultOptionLabel}
          </option>
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : type === "file" ? (
        <input
          type="file"
          name={name}
          id={name}
          onChange={onChange}
          required={required}
          disabled={disabled}
          accept={accept}
          aria-describedby={error ? `${name}-error` : undefined}
          className={`input w-full p-1 border rounded-xl bg-white text-black disabled:bg-gray-100 disabled:text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-cyan-50 file:text-cyan-700 hover:file:bg-cyan-100 ${
            error ? "border-red-900" : "border-gray-300"
          }`}
          {...props}
        />
      ) : type === "textarea" ? (
        <textarea
          name={name}
          id={name}
          value={value}
          onChange={onChange}
          required={required}
          placeholder={placeholder}
          disabled={disabled}
          rows={rows}
          style={style}
          aria-describedby={error ? `${name}-error` : undefined}
          className={`input w-full p-4 border rounded-xl bg-white text-black disabled:bg-gray-100 disabled:text-gray-500 resize-y ${
            error ? "border-red-900" : "border-gray-300"
          }`}
          {...props}
        />
      ) : (
        <div className="relative w-full">
          {startIcon && (
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
              {startIcon}
            </span>
          )}
          <input
            type={type}
            name={name}
            id={name}
            value={value}
            onChange={onChange}
            required={required}
            placeholder={placeholder}
            disabled={disabled}
            aria-describedby={error ? `${name}-error` : undefined}
            className={`input w-full p-2 ${
              startIcon ? "pl-10" : "p-4"
            } border rounded-xl bg-white text-black disabled:bg-gray-100 disabled:text-gray-500 ${
              error ? "border-red-900" : "border-gray-300"
            }`}
            {...props}
          />
        </div>
      )}

      {error && (
        <p id={`${name}-error`} className="text-red-500 text-sm mt-1">
          {error}
        </p>
      )}
    </div>
  );
};
